import {
  ButtonsPremiumState,
  IndicatorAddonStatePremium,
  IndicatorLockStatePremium,
  IndicatorNetStatePremium,
  IndicatorPurifierStatePremium,
  IndicatorUvStatePremium,
  IndicatorWifiStatePremium,
  PouringAnimation,
  SimulatorPremiumPagesInterface
} from '../../interfaces/simulator-premium';
import {Personal} from '../data/personal';
import {Jug} from '../data/jug';
import {Setting} from '../data/setting';
import {Maintenance} from '../data/maintenance';
import {WashingTank} from '../data/washingTank';
import {Reset} from '../data/reset';
import {Preference} from '../data/preference';
import {QuantityAndTemp} from '../data/quantityAndTemp';
import {InternalCleaning} from '../data/internalCleaning';
import {ButtonHelper} from '../helpers/buttonHelper';
import {MuteService} from '../../../../mute.service';
import {TechScreen} from '../data/techScreen';

export class MixWaterBtn {

  public static isMute = null;

  constructor(private muteService: MuteService) {
    MixWaterBtn.isMute = this.muteService.getMode();
    this.muteService.mute.subscribe((mute) => {
      MixWaterBtn.isMute = mute;
    });
  }

  public static shortClick(isMute): void {
    MixWaterBtn.isMute = isMute;
    switch (ButtonHelper.simulator.page) {

      // screen IDLE
      case SimulatorPremiumPagesInterface.IDLE:
      case SimulatorPremiumPagesInterface.ParametersTech:
        ButtonHelper.resetMainAfk();
        ButtonHelper.simulatorMix();

        // finish dispensing and go back to idle screen
        ButtonHelper.afkDispensingWater = setTimeout(() => {
          ButtonHelper.mainSimulatorScreen();
        }, ButtonHelper.DISPENSING_WATER_TIME + 2000);
        break;

      // screen dispensing hot water
      case SimulatorPremiumPagesInterface.MixWaterDispensing:
      case SimulatorPremiumPagesInterface.HotWaterDispensing:
      case SimulatorPremiumPagesInterface.ColdWaterDispensing:
        ButtonHelper.mainSimulatorScreen();
        break;

      // screen Personal
      case SimulatorPremiumPagesInterface.Personal:
        ButtonHelper.startMainAfk();
        Personal.currentUser = Personal.users[ButtonHelper.lang][ButtonHelper.buttonsIndexes.mix + Personal.currentUserPage];
        ButtonHelper.simulatorPersonalDrinks();
        break;

      case SimulatorPremiumPagesInterface.PersonalDrinks:
        ButtonHelper.resetMainAfk();
        ButtonHelper.simulatorDispensingPersonal(ButtonHelper.buttonsIndexes.mix);
        Personal.currentUserPage = 0;
        break;

      case SimulatorPremiumPagesInterface.Jugs:
        ButtonHelper.simulatorDispensingJugs(ButtonHelper.buttonsIndexes.mix);
        break;

      case SimulatorPremiumPagesInterface.ActivateJugs:
        ButtonHelper.pouringAudio.load();
        if (Jug.step === 1 && Jug.currentJug.run === SimulatorPremiumPagesInterface.MixWaterDispensing) {
          ButtonHelper.pouringAudio.loop = true;
          if (!MixWaterBtn.isMute) {
            ButtonHelper.pouringAudio.play(); // done
          }
          ButtonHelper.resetMainAfk();
          Jug.step++;
          ButtonHelper.simulatorActivateJug();
          ButtonHelper.simulator.pouring = {animation: PouringAnimation.MIX, fast: false};
        } else if (Jug.step === 2) {
          Jug.step++;
          ButtonHelper.pouringAudio.pause();
          ButtonHelper.startMainAfk();
          ButtonHelper.simulatorActivateJug();
          if (Jug.step == 3) {
            ButtonHelper.startMainAfk();
            ButtonHelper.simulator.buttons = {
              hot: {active: true, state: ButtonsPremiumState.NO_ICON},
              cold: {active: true, state: ButtonsPremiumState.NO_ICON},
              mix: {active: true, state: ButtonsPremiumState.NO_ICON},
              boiling: {active: true, state: ButtonsPremiumState.BORDER},
              jugs: {active: true, state: ButtonsPremiumState.NO_ICON},
              personal: {active: true, state: ButtonsPremiumState.BORDER}
            };
          }
        } else if (Jug.step === 4) {
          ButtonHelper.startMainAfk();
          Jug.incTemp();
        }
        break;

      case SimulatorPremiumPagesInterface.Menu:
        ButtonHelper.startMainAfk();
        ButtonHelper.simulator = {
          indicator: {
            addon: {active: false, state: IndicatorAddonStatePremium.OFF},
            uv: {active: false, state: IndicatorUvStatePremium.BLUE},
            wifi: {active: false, state: IndicatorWifiStatePremium.OFF},
            clock: {active: false},
            lock: {active: false, state: IndicatorLockStatePremium.OFF},
            purifier: {active: false, state: IndicatorPurifierStatePremium.BLUE},
            net: {active: false, state: IndicatorNetStatePremium.OFF}
          },
          page: SimulatorPremiumPagesInterface.Support,
          pouring: {fast: false, animation: PouringAnimation.NONE},
          buttons: {
            hot: {active: true, state: ButtonsPremiumState.NO_BORDER},
            cold: {active: true, state: ButtonsPremiumState.NO_BORDER},
            mix: {active: true, state: ButtonsPremiumState.NO_BORDER},
            boiling: {active: true, state: ButtonsPremiumState.BORDER},
            jugs: {active: true, state: ButtonsPremiumState.NO_BORDER},
            personal: {active: true, state: ButtonsPremiumState.NO_BORDER}
          }
        };
        break;

      case SimulatorPremiumPagesInterface.Settings:
        ButtonHelper.startMainAfk();
        if (!Setting.isEditMode) {
          if (Setting.currentIndex > 0) {
            Setting.currentIndex--;
            Setting.swiper.slidePrev();

            if (Setting.currentIndex === 0) {
              ButtonHelper.simulator.buttons.mix.state = ButtonsPremiumState.NO_BORDER;
            } else {
              ButtonHelper.simulator.buttons.jugs.state = ButtonsPremiumState.BORDER;
            }
          }
        } else if (Setting.isLanguage) {
          if (Setting.currentLanguageIndex > 0) {
            Setting.currentLanguageIndex--;
            Setting.languageSwiper.slidePrev();
          }
        } else if (Setting.isDateTime) {
          if (!Setting.isSetTime && !Setting.isSetDate) {
            if (Setting.currentDateTimeIndex > 0) {
              Setting.currentDateTimeIndex--;
              Setting.dateTimeSwiper.slidePrev();
            }
          } else {
            Setting.incTime();
          }
        } else {
          if (Setting.settingsList[ButtonHelper.lang][Setting.currentIndex]['type'] === 1) {
            if (!Setting.isDeactivatedConformation) {
              Setting.settingsList[ButtonHelper.lang][Setting.currentIndex]['value'] = false;
            } else {
              ButtonHelper.startMainAfk();
              ButtonHelper.simulatorSettings();
            }
          } else if (Setting.settingsList[ButtonHelper.lang][Setting.currentIndex]['type'] === 2) {
            Setting.settingsList[ButtonHelper.lang][Setting.currentIndex]['value'] = false;
          }
        }
        break;

      case SimulatorPremiumPagesInterface.Maintenance:
        ButtonHelper.startMainAfk();
        if (Maintenance.currentIndex > 0) {
          Maintenance.currentIndex--;
          Maintenance.maintenanceSwiper.slidePrev();

          if (Maintenance.currentIndex === 0) {
            ButtonHelper.simulator.buttons.mix.state = ButtonsPremiumState.NO_BORDER;
          } else {
            ButtonHelper.simulator.buttons.jugs.state = ButtonsPremiumState.BORDER;
          }
        }
        break;

      case SimulatorPremiumPagesInterface.WashingTank:
        if (WashingTank.step === 2) {
          WashingTank.isPause = !WashingTank.isPause;
        } else if (WashingTank.step === 4) {
          WashingTank.isPause = !WashingTank.isPause;
        }
        break;

      case SimulatorPremiumPagesInterface.ShabbatModeConfirmation:
        ButtonHelper.simulatorMaintenance();
        ButtonHelper.startMainAfk();
        break;

      case SimulatorPremiumPagesInterface.ShabbatModeConfirmationHome:
        ButtonHelper.mainSimulatorScreen();
        ButtonHelper.resetMainAfk();
        break;

      case SimulatorPremiumPagesInterface.Reset:
        ButtonHelper.startMainAfk();
        if (Reset.screen === 1) {
          if (Reset.currentIndex > 0) {
            Reset.currentIndex--;
            Reset.resetSwiper.slidePrev();
            if (Reset.currentIndex === 0) {
              ButtonHelper.simulator.buttons.mix.state = ButtonsPremiumState.NO_BORDER;
              ButtonHelper.simulator.buttons.jugs.state = ButtonsPremiumState.BORDER;
            }
          }
        } else if (Reset.screen === 2) {
          Reset.screen = 1;
          ButtonHelper.simulatorFactory();
          ButtonHelper.startMainAfk();
        }
        break;

      case SimulatorPremiumPagesInterface.Preferences:
        ButtonHelper.startMainAfk();
        if (Preference.currentIndex > 0) {
          Preference.currentIndex--;
          Preference.preferenceSwiper.slidePrev();

          if (Preference.currentIndex === 0) {
            ButtonHelper.simulator.buttons.mix.state = ButtonsPremiumState.NO_BORDER;
            ButtonHelper.simulator.buttons.jugs.state = ButtonsPremiumState.BORDER;
          }
        }
        break;

      case SimulatorPremiumPagesInterface.QuantityAndTemp:
        QuantityAndTemp.currentDrinks = QuantityAndTemp.drinks[ButtonHelper.lang][ButtonHelper.buttonsIndexes.mix];
        QuantityAndTemp.step = 1;
        ButtonHelper.simulator = {
          indicator: {
            addon: {active: false, state: IndicatorAddonStatePremium.OFF},
            uv: {active: false, state: IndicatorUvStatePremium.OFF},
            wifi: {active: false, state: IndicatorWifiStatePremium.OFF},
            clock: {active: false},
            lock: {active: false, state: IndicatorLockStatePremium.OFF},
            purifier: {active: false, state: IndicatorPurifierStatePremium.OFF},
            net: {active: false, state: IndicatorNetStatePremium.OFF}
          },
          page: SimulatorPremiumPagesInterface.WaterQuantity,
          pouring: {fast: false, animation: PouringAnimation.NONE},
          buttons: {
            hot: {active: true, state: ButtonsPremiumState.ICON_NO_BRIGHT},
            cold: {active: true, state: ButtonsPremiumState.ICON_NO_BRIGHT},
            mix: {active: true, state: ButtonsPremiumState.FLASH},
            boiling: {active: true, state: ButtonsPremiumState.BORDER},
            jugs: {active: true, state: ButtonsPremiumState.ICON_NO_BRIGHT},
            personal: {active: true, state: ButtonsPremiumState.BORDER}
          }
        };
        break;

      case SimulatorPremiumPagesInterface.WaterQuantity:
        ButtonHelper.pouringAudio.load();
        if (QuantityAndTemp.step === 1) {
          if (QuantityAndTemp.currentDrinks.run === SimulatorPremiumPagesInterface.MixWaterDispensing) {
            ButtonHelper.simulator.buttons.mix.state = ButtonsPremiumState.ICON_BRIGHT;
            ButtonHelper.simulator.buttons.boiling.state = ButtonsPremiumState.ICON_NO_BRIGHT;
            ButtonHelper.simulator.buttons.personal.state = ButtonsPremiumState.ICON_NO_BRIGHT;
            ButtonHelper.simulator.pouring.animation = PouringAnimation.MIX;
            QuantityAndTemp.step = 2;

            ButtonHelper.pouringAudio.loop = true;
            if (!MixWaterBtn.isMute) {
              ButtonHelper.pouringAudio.play(); // done
            }
          }
          ButtonHelper.resetMainAfk();
        } else if (QuantityAndTemp.step === 2) {
          ButtonHelper.pouringAudio.pause();
          if (QuantityAndTemp.currentDrinks.run === SimulatorPremiumPagesInterface.MixWaterDispensing) {
            ButtonHelper.simulator.buttons = {
              hot: {active: true, state: ButtonsPremiumState.NO_ICON},
              cold: {active: true, state: ButtonsPremiumState.NO_ICON},
              mix: {active: true, state: ButtonsPremiumState.NO_ICON},
              boiling: {active: true, state: ButtonsPremiumState.BORDER},
              jugs: {active: true, state: ButtonsPremiumState.NO_ICON},
              personal: {active: true, state: ButtonsPremiumState.BORDER}
            };
            ButtonHelper.simulator.pouring.animation = PouringAnimation.NONE;
            QuantityAndTemp.step = 3;
          }
        } else if (QuantityAndTemp.step === 4) {
          QuantityAndTemp.incTemp();
        }
        break;

      case SimulatorPremiumPagesInterface.PersonalQuantity:
        Personal.currentUser = Personal.users[ButtonHelper.lang][ButtonHelper.buttonsIndexes.mix + Personal.currentUserPage];
        ButtonHelper.simulatorEditPersonalQuantity();
        ButtonHelper.startMainAfk();
        break;

      case SimulatorPremiumPagesInterface.EditPersonalQuantity:
        ButtonHelper.startMainAfk();
        QuantityAndTemp.currentDrinks = Personal.currentUser.drinks[ButtonHelper.buttonsIndexes.mix];
        QuantityAndTemp.step = 1;
        ButtonHelper.simulator = {
          indicator: {
            addon: {active: false, state: IndicatorAddonStatePremium.OFF},
            uv: {active: false, state: IndicatorUvStatePremium.OFF},
            wifi: {active: false, state: IndicatorWifiStatePremium.OFF},
            clock: {active: false},
            lock: {active: false, state: IndicatorLockStatePremium.OFF},
            purifier: {active: false, state: IndicatorPurifierStatePremium.OFF},
            net: {active: false, state: IndicatorNetStatePremium.OFF}
          },
          page: SimulatorPremiumPagesInterface.WaterQuantity,
          pouring: {fast: false, animation: PouringAnimation.NONE},
          buttons: {
            hot: {active: true, state: ButtonsPremiumState.FLASH},
            cold: {active: true, state: ButtonsPremiumState.ICON_NO_BRIGHT},
            mix: {active: true, state: ButtonsPremiumState.ICON_NO_BRIGHT},
            boiling: {active: true, state: ButtonsPremiumState.BORDER},
            jugs: {active: true, state: ButtonsPremiumState.ICON_NO_BRIGHT},
            personal: {active: true, state: ButtonsPremiumState.BORDER}
          }
        };
        break;

      case SimulatorPremiumPagesInterface.InternalCleaningMain:
        ButtonHelper.startMainAfk();
        if (InternalCleaning.currentIndex > 0) {
          InternalCleaning.currentIndex--;
          InternalCleaning.internalSwiper.slidePrev();

          if (InternalCleaning.currentIndex === 0) {
            ButtonHelper.simulator.buttons.mix.state = ButtonsPremiumState.NO_BORDER;
            ButtonHelper.simulator.buttons.jugs.state = ButtonsPremiumState.BORDER;
          }
        }
        break;

      case SimulatorPremiumPagesInterface.Descaling:
        // mix
        if (InternalCleaning.step === 5 || InternalCleaning.step === 8 || InternalCleaning.step === 13) {
          if (!InternalCleaning.isPause) {
            ButtonHelper.simulator.pouring.animation = PouringAnimation.NONE;
            ButtonHelper.pouringAudio.pause();
            InternalCleaning.isPause = true;
          }
        }
        break;

      case SimulatorPremiumPagesInterface.Sterilization:
        // mix
        if (InternalCleaning.step === 3 || InternalCleaning.step === 6 || InternalCleaning.step === 9 || InternalCleaning.step === 13) {
          if (!InternalCleaning.isPause) {
            InternalCleaning.isPause = true;
            ButtonHelper.pouringAudio.pause();
            ButtonHelper.simulator.pouring.animation = PouringAnimation.NONE;
          }
        }
        break;

      case SimulatorPremiumPagesInterface.Tech:
        if (TechScreen.currentIndex > 0) {
          TechScreen.currentIndex--;
          TechScreen.techScreenSwiper.slidePrev();

          if (TechScreen.currentIndex === 0) {
            ButtonHelper.simulator.buttons.mix.state = ButtonsPremiumState.NO_BORDER;
            // ButtonHelper.simulator.buttons.jugs.state = ButtonsPremiumState.BORDER;
          } else {
            ButtonHelper.simulator.buttons.jugs.state = ButtonsPremiumState.BORDER;
          }
        }
        break;

      case SimulatorPremiumPagesInterface.ChildLockTech:
        TechScreen.defaults.childLock.current = false;
        break;
      case SimulatorPremiumPagesInterface.DebugTech:
        TechScreen.defaults.debug.current = false;
        break;

      case SimulatorPremiumPagesInterface.TempTech:
        if (TechScreen.defaults.temp.current < 100) {
          TechScreen.defaults.temp.current++;
        }
        break;
    }
  }

  public static longClickDown(isMute): void {
    switch (ButtonHelper.simulator.page) {

      case SimulatorPremiumPagesInterface.IDLE:
        ButtonHelper.resetMainAfk();
        ButtonHelper.simulatorMix(true);
        break;

      case SimulatorPremiumPagesInterface.ShabbatModeScreen:
        ButtonHelper.resetMainAfk();
        ButtonHelper.mainSimulatorScreen();
        break;
    }
  }

  public static longClickUp(isMute): void {
    switch (ButtonHelper.simulator.page) {

      case SimulatorPremiumPagesInterface.MixWaterDispensing:
        ButtonHelper.mainSimulatorScreen();
        break;
    }
  }
}
